// extracted by mini-css-extract-plugin
export var author = "ReviewsItem-module--author--d01f0";
export var card = "ReviewsItem-module--card--6c3eb";
export var container = "ReviewsItem-module--container--49be6";
export var divider = "ReviewsItem-module--divider--d70b4";
export var rating = "ReviewsItem-module--rating--9238d";
export var review = "ReviewsItem-module--review--2c25f";